import axios from 'axios';

function delay(time, value) {
  return new Promise((resolve) => setTimeout(resolve.bind(null, value), time));
}
const tenant = window.location.hostname.split('.')[0];
const publicFetch = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'app-tenant': tenant,
  },
});

export { publicFetch, delay };
